module.exports = __webpack_public_path__ + "img/Cereri_si_Oferte.cfa69581.png";